export const businessUnitOption = [
    "Connect",
    "CLP",
    "Comcast Business",
    "CPE",
    "Cyber Security",
    "Databee",
    "EBI",
    "Effectv Engineering",
    "Effectv Ops",
    "Freewheel",
    "IS Solutions",
    "GTO",
    "GREE",
    "NBCU",
    "SCM",
    "SB& A",
    "SKY Cloud Infra",
    "SKY CT&I",
    "Sky Cyber",
    "SKY Data",
    "SKY Digital",
    "SKY Digital IM",
    "SKY GASD & TTS",
    "SKY Germany",
    "SKY GETS/GWS",
    "SKY GSM",
    "SKY Italy",
    "SKY Italy C&I",
    "SKY News",
    "SKY Telco",
    "SKY UKCTO",
    "Support Functions",
    "Strata",
    "UDX",
    "Video",
    "Xumo"
] as const

export const referral_window_open = true;

export type Candidates = {
    id: any,
    name: any,
    email: any,
    phone: any,
    skills: any,
    position: any,
    experience: any,
    current_ctc: any,
    expected_ctc: any,
    location: any,
    gender: any,
    status: any,
    referrer_businessunit: any,
    referrer_positionid: any,
    referrering_businessunit:any,
    notice_period:any,
    referrer_name: any,
    referrer_email: any,
    recruiter_remarks: any,
    file_name: any,
    file_type: any,
    file_path: any,
    created_by: any,
    modified_by: any,
    createdAt: any,
    updatedAt: any,
}
